const translations = {
  "en": {
    "%{var0} moves get you there sooner": "%{var0} moves get you there sooner"
  },
  "zh-tw": {
    "%{var0} moves get you there sooner": "%{var0}操作助你更快達標"
  }
};

export default translations;
